import { Component } from '@angular/core';
import { MatCardContent, MatCardHeader, MatCard, MatCardTitle } from "@angular/material/card";
import { MatTableModule } from '@angular/material/table';
import { MatIcon } from "@angular/material/icon";
import { MatTabGroup, MatTab } from "@angular/material/tabs";
import { MatDialogContent, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'app-commission-calculation-steps',
  imports: [MatTableModule, MatTabGroup, MatTab],
  templateUrl: './commission-calculation-steps-dialog.component.html',
  styleUrls: ['./commission-calculation-steps-dialog.component.scss']
})
export class CommissionCalculationStepsComponent {
  displayedColumns: string[] = ['step', 'name', 'formula'];
  constructor(private dialogRef: MatDialogRef<CommissionCalculationStepsComponent>) {}

  contractCalculationData: any[] = [
    { step: 1, name: 'Revenue', formula: '(Bill Rate * (Reg hours - Free Hours)) + (Bill Rate * 1.5 * OT hours) + (Bill Rate * 2 * OT2 Hours)' },
    { step: 2, name: 'Commission Gross Margin', formula: '(Bill rate - Pay Rate - (Pay rate * Fixed Burden)) * (Reg Hours + (1.5 * OT Hours) + (2 * OT2 Hours) - Free Hours)' },
    { step: 3, name: 'Burden', formula: 'Revenue - Commission Gross Margin' },
    { step: 4, name: 'Adjusted Margin', formula: 'Commission Gross Margin - Discounts - VMS Fees' },
    { step: 5, name: 'Commissionable Contribution', formula: 'If Bill Rate < Bill Rate Threshold, (Adjusted Margin * Bill Rate Margin Impact) * (1 - Bid Support), else, Adjusted Margin * (1 - Bid Support)' },
    { step: 6, name: 'Account Manager Split', formula: 'Commissionable Contribution * 20%' },
    { step: 7, name: 'Placement Service Split', formula: 'Commissionable Contribution * 20%' },
    { step: 8, name: 'Business Development Split', formula: 'Commissionable Contribution * 10%' },
    { step: 9, name: 'Interviewer Split %', formula: 'If Candidate Interview Date <= 180 days from the placement Start Date, Percentage = 25%' },
    { step: 9, name: 'Interviewer Split', formula: 'Commissionable Contribution * 0.25' },
    { step: 10, name: 'Recruiter Split', formula: 'Commissionable Contribution * (50% - Interview Split %)' },
    { step: 11, name: 'Account Manager Payout', formula: 'Account Manager Split * Owners Commission Rate' },
    { step: 12, name: 'Placement Service Payout', formula: 'Placement Service Split * Owners Commission Rate' },
    { step: 13, name: 'Business Development Payout', formula: 'Business Development Split * Owners Commission Rate' },
    { step: 14, name: 'Interviewer Payout', formula: 'Interviewer Split * Owners Commission Rate' },
    { step: 15, name: 'Recruiter Payout', formula: 'Recruiter Split * Owners Commission Rate' }
  ];
  permCalculationData: any[] = [
    { step: 1, name: 'Check Invoice Status', formula: 'If Invoice Status = Paid, continue to step 2, else mark invoice as "Pending Client Payment"' },
    { step: 2, name: 'Revenue', formula: 'Fee $ - Discounts-VMS' },
    { step: 3, name: 'Burden', formula: 'Revenue * Burden' },
    { step: 4, name: 'Gross Commission Margin', formula: 'Revenue - Burden' },
    { step: 5, name: 'Adjusted Margin', formula: 'Commission Gross Margin - Discounts - VMS Fees' },
    { step: 6, name: 'Commissionable Contribution', formula: 'Adjusted Margin * (1-Bid Support))' },
    { step: 7, name: 'Account Manager Split', formula: 'Commissionable Contribution * 30%' },
    { step: 8, name: 'Placement Service Split', formula: 'Commissionable Contribution * 10%' },
    { step: 9, name: 'Business Development Split', formula: 'Commissionable Contribution * 10%' },
    { step: 10, name: 'Interviewer Split %', formula: 'If Candidate Interview Date is =<180 days from the placement Start Date, Percentage = 25%' },
    { step: 11, name: 'Interviewer Split', formula: 'Commissionable Contribution * 0.25' },
    { step: 12, name: 'Recruiter Split', formula: 'Commissionable Contribution * (50% - Interview Split %)' },
    { step: 13, name: 'Account Manager Payout', formula: 'Account Manager Split * Owners Commission Rate' },
    { step: 14, name: 'Placement Service Payout', formula: 'Placement Service Split * Owners Commission Rate' },
    { step: 15, name: 'Business Development Payout', formula: 'Business Development Split * Owners Commission Rate' },
    { step: 16, name: 'Interviewer Payout', formula: 'Interviewer Split * Owners Commission Rate' },
    { step: 17, name: 'Recruiter Payout', formula: 'Recruiter Split * Owners Commission Rate' }
  ];

closeDialog(): void {
    this.dialogRef.close();
  }
}
